<template>
  <div class="div-icon-container">
    <div class="icon-container">
      <svg width="19" height="31" viewBox="0 0 19 31" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.55739 30.8002C6.40057 30.8002 6.24247 30.7721 6.09074 30.7109C5.52337 30.4878 5.19314 29.8937 5.30407 29.2944L7.37977 18.0119H1.85009C1.37579 18.0119 0.939742 17.748 0.720442 17.3273C0.499867 16.9065 0.531742 16.3991 0.802042 16.0089L11.3947 0.747172C11.7364 0.255022 12.3765 0.0701473 12.9222 0.293272C13.4755 0.518947 13.7981 1.0978 13.6987 1.68557L12.0169 11.6752H17.1501C17.6155 11.6752 18.0439 11.9289 18.2683 12.3382C18.4927 12.7475 18.4748 13.2447 18.2249 13.6374L7.63222 30.2124C7.39252 30.5873 6.98197 30.8002 6.55739 30.8002Z" fill="#ECF8FF"/>
      </svg>
    </div>
  </div>
  <div class="screen-settings fixed bottom-0 left-0 w-full bg-[#1A1420] pt-2 p-4">
    <div class="flex justify-between items-center mb-4">
      <div class="flex items-center">
        <div class="ml-[70px]">
          <p class="font-bold text-white">Configurações</p>
          <p class="text-gray-500">{{ selectedGame.name }}</p>
        </div>
      </div>
      <div class="flex items-center bg-[#FFFFFF0A] rounded-full p-2">
        <div class="status-indicator" :class="{ 'active': isActive, 'inactive': !isActive }"></div>
        <span class="text-gray-400 ml-2">{{ isActive ? 'Ativo' : 'Inativo' }}</span>
        <label class="switch ml-2">
          <CustomCheckbox :model-value="isActive" @update:model-value="updateChecked('isActive', $event)" class="mr-2" />
        </label>
      </div>
    </div>
    <div class="settings-content bg-[#211A27] p-2 rounded-lg">
      <div class="flex items-center mb-4">
        <CustomCheckbox :model-value="checked1" @update:model-value="updateChecked('checked1', $event)" class="mr-2" />
        <span class="ml-3 text-white">Soltando mais cartinhas</span>
      </div>
      <div class="flex items-center mb-4">
        <CustomCheckbox :model-value="checked2" @update:model-value="updateChecked('checked2', $event)" class="mr-2" />
        <span class="ml-3 text-white">Multiplicador maior</span>
      </div>
      <div class="flex items-center mb-0">
        <CustomCheckbox :model-value="checked3" @update:model-value="updateChecked('checked3', $event)" class="mr-2" />
        <span class="ml-3 text-white">Super mega ganho</span>
      </div>
    </div>
    <div class="flex justify-between items-center mt-4 space-x-20">
      <button class="expand-button text-white py-2 rounded-lg flex items-center" @click="expandGame">
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-1">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M17.7031 0H4.29688C3.15795 0.00219179 2.06629 0.455601 1.26095 1.26095C0.455601 2.06629 0.00219154 3.15795 0 4.29688V17.7031C0.00219154 18.8421 0.455601 19.9337 1.26095 20.7391C2.06629 21.5444 3.15795 21.9978 4.29688 22H17.7031C18.8421 21.9978 19.9337 21.5444 20.7391 20.7391C21.5444 19.9337 21.9978 18.8421 22 17.7031V4.29688C21.9978 3.15795 21.5444 2.06629 20.7391 1.26095C19.9337 0.455601 18.8421 0.00219179 17.7031 0ZM17.4453 16.6397C17.4453 16.8533 17.3604 17.0582 17.2093 17.2093C17.0582 17.3604 16.8533 17.4453 16.6396 17.4453H12.423C12.3165 17.4464 12.2108 17.4264 12.1121 17.3864C12.0134 17.3464 11.9236 17.2872 11.8479 17.2123C11.7722 17.1374 11.7121 17.0482 11.6711 16.9499C11.6301 16.8516 11.609 16.7462 11.609 16.6396C11.609 16.5331 11.6301 16.4277 11.6711 16.3294C11.7121 16.2311 11.7722 16.1419 11.8479 16.067C11.9236 15.9921 12.0134 15.9329 12.1121 15.8929C12.2108 15.8529 12.3165 15.8329 12.423 15.834H14.6945L11.6953 12.8348C11.5442 12.6837 11.4593 12.4787 11.4593 12.265C11.4592 12.0513 11.5441 11.8463 11.6952 11.6952C11.77 11.6204 11.8589 11.561 11.9566 11.5205C12.0544 11.48 12.1592 11.4592 12.265 11.4592C12.4787 11.4591 12.6836 11.544 12.8348 11.6951L15.834 14.6948V12.423C15.8362 12.2108 15.922 12.008 16.0729 11.8587C16.2237 11.7094 16.4274 11.6256 16.6396 11.6256C16.8519 11.6256 17.0556 11.7094 17.2064 11.8587C17.3573 12.008 17.4431 12.2108 17.4453 12.423V16.6397ZM4.55469 5.36039C4.55473 5.14673 4.63963 4.94183 4.79071 4.79074C4.94179 4.63965 5.14669 4.55474 5.36035 4.55469H9.577C9.68351 4.55359 9.78917 4.57361 9.88788 4.61361C9.98659 4.6536 10.0764 4.71277 10.1521 4.7877C10.2278 4.86262 10.2879 4.95181 10.3289 5.0501C10.3699 5.14839 10.391 5.25384 10.391 5.36035C10.391 5.46686 10.3699 5.57231 10.3289 5.6706C10.2879 5.7689 10.2278 5.85809 10.1521 5.93301C10.0764 6.00793 9.98659 6.0671 9.88788 6.10709C9.78917 6.14709 9.68351 6.16712 9.577 6.16602H7.30525L10.3049 9.16523C10.456 9.31636 10.5409 9.52134 10.5409 9.73506C10.5409 9.94879 10.456 10.1538 10.3049 10.3049C10.1538 10.456 9.94879 10.5409 9.73506 10.5409C9.52134 10.5409 9.31636 10.456 9.16523 10.3049L6.16602 7.30525V9.57705C6.16382 9.78928 6.07798 9.99208 5.92712 10.1414C5.77627 10.2907 5.5726 10.3744 5.36035 10.3744C5.14811 10.3744 4.94443 10.2907 4.79358 10.1414C4.64273 9.99208 4.55688 9.78928 4.55469 9.57705V5.36039Z" fill="#4B4860"/>
        </svg>
        Expandir
      </button>
      <button class="save-button text-white py-2 rounded-lg" @click="saveSettings">Salvar ajustes</button>
    </div>
  </div>
</template>

<script>
import CustomCheckbox from '@/components/CustomCheckbox.vue';

export default {
  name: 'ScreenSettings',
  components: {
    CustomCheckbox
  },
  props: ['selectedGame', 'checked1', 'checked2', 'checked3', 'isActive'],

  methods: {
    expandGame() {
      console.log('Expanding game')
      this.$emit('expand-game', this.selectedGame);
    },
    saveSettings() {
      this.$emit('save-settings');
    },
    updateChecked(key, value) {
      console.log('Updating checked', key, value);
      this.$emit('update-checked', {
        checked1: key === 'checked1' ? value : this.checked1,
        checked2: key === 'checked2' ? value : this.checked2,
        checked3: key === 'checked3' ? value : this.checked3,
        isActive: key === 'isActive' ? value : this.isActive,
      });
    }
  }
};
</script>

<style scoped>
.div-icon-container {
  position: fixed;
  bottom: 212px;
  left: 45px;
  transform: translateX(-50%);
  z-index: 10;
}

.screen-settings {
  max-height: 80vh;
  max-width: 600px;
  overflow-y: auto;
  align-self: center;
}

.icon-container {
  background-color: #2555FF;
  color: white;
  border-radius: 12px;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 0px 16.6px 0px #2555FF;
  margin-top: -30px;
  z-index: 10;
}

.status-indicator {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 2px solid #ECF8FF;
}

.status-indicator.active {
  background-color: #25FF7C;
}

.status-indicator.inactive {
  background-color: #FF4B4B;
}

.switch {
  position: relative;
  display: inline-block;
  width: 34px;
  height: 20px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 34px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 14px;
  width: 14px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #2196F3;
}

input:checked + .slider:before {
  transform: translateX(14px);
}

.expand-button {
  background-color: #4B486024;
  display: flex;
  align-items: center;
  padding-left: 10px;
  padding-right: 10px;
}

.save-button {
  background-color: #2555FF;
  flex-grow: 1;
  margin-left: 10px;
}
</style>
